import React from "react";

export const useOutsideClick = (callback) => {
    const ref = React.useRef();

    React.useEffect(() => {
        const handleClick = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        };

        document.addEventListener("click", handleClick, true);
        window.addEventListener("touchstart", handleClick, true);
        window.addEventListener("touch", handleClick, true);

        return () => {
            document.removeEventListener("click", handleClick, true);
            window.removeEventListener("touchstart", handleClick, true);
            window.removeEventListener("touch", handleClick, true);
        };
    }, [ref]);

    return ref;
};
